<template>
  <div class="list-wrap">
    <div class="productName">
      <img
        :src="
          require('@/assets/pingxuan2024/common/images/title/' + pTitle + '.png')
        "
      />
    </div>
    <!-- 产品列表 -->
    <div class="productList">
      <ul v-if="pList">
        <li v-for="(listCart, i) in pList" :key="i"  @click="jumpBuy(listCart.shop_url)">
          <div class="p-image">
            <span>
              <img
              v-lazy="
                require('@/assets/pingxuan2024/common/images/'+listCart.dir+'/'+listCart.product_name+'.png')
                "
                alt=""
                :style="{width: listCart.width_pc + 'px'}"
              >
            </span>
          </div>
          <div class="productFont">
            <div v-if="listCart.product_name === '海尔博观 AI智慧全空间保鲜冰箱BCD-650WGHFD 1 2STU 1'" class="productType"  style="font-size: 16px;" >
              {{ listCart.product_name }}</div>
            <div v-else class="productType">{{ listCart.product_name }}</div>
            <div class="productWords">{{ listCart.desc }}</div>
          </div>
          <div class="bottom-img">
            <img class="quotation load" src="@/assets/pingxuan2024/pc/images/load.png" alt="">
            <img class="quotation douhao" src="@/assets/pingxuan2024/pc/images/douhao.png" alt="">
          </div>
        </li>
      </ul>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    pTitle: {
      type: String
    },
    pList: {
      type: Array,
      default () {
        return []
      }
    },
    pIndex: {
      type: Number
    }
  },
  name: 'part',
  components: {
  },
  data() {
    return {
      color_39EAB5: '#39EAB5',
      color_FF9E45: '#FF9E45'
    }
  },
  methods:{
    jumpBuy(url){
    //  window.location.href = url
    },
  },
  computed: {
    colorStyle() {
      return this.pIndex % 2 == 0 ? this.color_39EAB5 : this.color_FF9E45
    },
    quotationStyleSrc() {
      return this.pIndex % 2 == 0 ? require('@/assets/pingxuan2022/pc/images/quotation.png') : require('@/assets/pingxuan2022/pc/images/quotation.png')
    }
  }
}
</script>
<style lang='scss' scoped>
.productName{
  img{
    height: 85px;
    display: block;
    margin: 0 auto;
  }
}
// 产品列表
.productList {
  width: 100%;
  margin-top: 43px;
  ul {
   width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    li{
      position: relative;
      width: 188px;
      height: 427px;
      border-radius: 8px;
      margin-bottom: 10px;
      background: linear-gradient(to bottom, #3c1383, #64019c);
      border: 1px solid #e6ca42;
      color: #FFFFFF;
      .p-image{
        width: 100%;
        height: 200px;
        display:table;
        text-align:center;
        span{
          display:table-cell;
          vertical-align:middle;
        }
        img{
          width: 122px;
        }

      }
      .productFont {
        text-align: justify;
        letter-spacing: -.3px;
      }
      .productFont .productType {
        height: 60px;
        padding: 0 10px;
        text-align: center;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 21px;
      }
      .productFont .productWords {
        padding: 10px 15px 0;
        width: 157px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 23px;
      }

      .line{
        overflow: hidden;
        width: 61px;
        height: 12px;
        font-size: 9px;
        font-family: zihun100hao-fangfangxianfengti, zihun100hao;
        font-weight: bolder;
        line-height: 19px;
        position: absolute;
        bottom: 10px;
        left: 9px;
        span{
          padding-left: 12px;
        }
      }
      .douhao{
        width: 24px;
        height: 20px;
        position: absolute;
        right: 10px;
        bottom: 20px;
      }
      .load{
        width: 60px;
        position: absolute;
        left: 10px;
        bottom: 25px;
      }
    }
  }
}
</style>
